import React from "react";
import MainMenu from "../components/navigations/MainMenu";
import { holidaysDays, importantDays } from "../data/calenderData";

export const DayContainer = ({ month, children }) => {
  return (
    <div className="border p-3 shadow-md md:shadow-none bg-white md:bg-gray-50 rounded w-64  my-2 hover:shadow-md hover:bg-white">
      <h1 className=" pb-2 underline text-2xl ">{month}</h1>
      <div>
        <ul className="list-disc pl-3 flex flex-col gap-y-2">{children}</ul>
      </div>
    </div>
  );
};

const CalenderAndHolidays = () => {
  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="pt-20">
        {/** Heading */}
        <div className="my-5">
          <h1 className="text-2xl font-serif text-center">
            Academic Calender 2021 - 2022
          </h1>
        </div>
        {/** List contaoiner */}
        <div className="flex flex-col items-center md:items-stretch md:flex-row p-2 md:p-6">
          {/** Important Days */}
          <div className="w-full md:w-1/2 mx-2 text-sm font-serif p-4 bg-blue-100 ">
            <h1 className="text-center text-2xl my-3">
              Lis of Important Days 2021 - 2022{" "}
            </h1>
            <div className="grid md:grid-cols-2">
              {importantDays.map((data) => {
                return (
                  <DayContainer month={data.month} key={data.id}>
                    {data.list.map((listData) => (
                      <li>{listData.name}</li>
                    ))}
                  </DayContainer>
                );
              })}
            </div>
          </div>
          <div className="w-full md:w-1/2 mx-2 text-sm font-serif p-4 bg-yellow-50">
            <h1 className="text-center text-2xl my-3">
              Lis of Holidays Days 2021 - 2022{" "}
            </h1>
            <div className="grid md:grid-cols-2">
              {holidaysDays.map((data) => {
                return (
                  <DayContainer month={data.month} key={data.id}>
                    {data.list.map((listData) => (
                      <li>{listData.name}</li>
                    ))}
                  </DayContainer>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalenderAndHolidays;
